import { useEffect, useCallback } from 'react';

interface KeyboardShortcut {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
  callback: () => void;
  description: string;
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcut[]) => {
  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    shortcuts.forEach(({ key, ctrlKey, shiftKey, altKey, metaKey, callback }) => {
      const isCtrlPressed = ctrlKey ? event.ctrlKey : !event.ctrlKey;
      const isShiftPressed = shiftKey ? event.shiftKey : !event.shiftKey;
      const isAltPressed = altKey ? event.altKey : !event.altKey;
      const isMetaPressed = metaKey ? event.metaKey : !event.metaKey;
      
      if (
        event.key.toLowerCase() === key.toLowerCase() &&
        isCtrlPressed &&
        isShiftPressed &&
        isAltPressed &&
        isMetaPressed
      ) {
        event.preventDefault();
        callback();
      }
    });
  }, [shortcuts]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};

